import React from 'react'
import { Outlet } from 'react-router'

function RegisterVehicleOutlet() {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default RegisterVehicleOutlet